export const getErrorResponse = (responseStatus: number, data: any) => {
  const status = data.status || responseStatus;
  const type = data.error?.type || 'unknown';
  const message = data.error?.message || `Error status: ${status}`;
  const traceId = data.error?.traceId || '';
  return { status, type, message, traceId };
};
